'use strict';
module.exports = function commonFileListContext(files) {
	if (!files || !Array.isArray(files)) {
		throw new Error('invalid-args');
	}
	const mergedContext = {},
		mergedKeys = [];

	if (files.length === 0) {
		return mergedContext;
	}
	if (files.length === 1) {
		Object.assign(mergedContext, (files[0] && files[0].context));
		if (files[0] && files[0].context && !mergedContext.recycleBin) {
			mergedContext.editMapSharing = true;
		}
		return mergedContext;
	}

	files.forEach(file => {
		if (!file || !file.context) {
			mergedKeys.forEach(key => mergedContext[key] = false);
		} else {
			mergedKeys.forEach(key => {
				mergedContext[key] = !!(mergedContext[key] && file.context[key]);
			});
			Object.keys(file.context).forEach(key => {
				if (!mergedKeys.includes(key)) {
					mergedKeys.push(key);
					mergedContext[key] = !!(file.context[key]);
				}
			});
		}

	});
	return mergedContext;
};
